// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file nodebase/v1/admin.proto (package nodebase.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { RequestMeta } from "./common_pb";
import { file_nodebase_v1_common } from "./common_pb";
import type { Device, PrivateOverlayLane } from "./device_pb";
import { file_nodebase_v1_device } from "./device_pb";
import type { EdgeAssignment, EdgeNode, EdgeRole } from "./edge_pb";
import { file_nodebase_v1_edge } from "./edge_pb";
import type { Endpoint, Transport, Worker, WorkerSpec } from "./worker_pb";
import { file_nodebase_v1_worker } from "./worker_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file nodebase/v1/admin.proto.
 */
export const file_nodebase_v1_admin: GenFile = /*@__PURE__*/
  fileDesc("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", [file_nodebase_v1_common, file_nodebase_v1_device, file_nodebase_v1_edge, file_nodebase_v1_worker]);

/**
 * @generated from message nodebase.v1.AdminListServicesRequest
 */
export type AdminListServicesRequest = Message<"nodebase.v1.AdminListServicesRequest"> & {
};

/**
 * Describes the message nodebase.v1.AdminListServicesRequest.
 * Use `create(AdminListServicesRequestSchema)` to create a new message.
 */
export const AdminListServicesRequestSchema: GenMessage<AdminListServicesRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 0);

/**
 * @generated from message nodebase.v1.AdminServiceStatus
 */
export type AdminServiceStatus = Message<"nodebase.v1.AdminServiceStatus"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: string region = 4;
   */
  region: string;

  /**
   * @generated from field: string worker_id = 5;
   */
  workerId: string;

  /**
   * healthy, degraded, stale, unknown, stopped. Never infer health from inventory.
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: int64 observed_unix = 7;
   */
  observedUnix: bigint;

  /**
   * @generated from field: string detail = 8;
   */
  detail: string;

  /**
   * @generated from field: string runtime = 9;
   */
  runtime: string;
};

/**
 * Describes the message nodebase.v1.AdminServiceStatus.
 * Use `create(AdminServiceStatusSchema)` to create a new message.
 */
export const AdminServiceStatusSchema: GenMessage<AdminServiceStatus> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 1);

/**
 * @generated from message nodebase.v1.AdminListServicesResponse
 */
export type AdminListServicesResponse = Message<"nodebase.v1.AdminListServicesResponse"> & {
  /**
   * @generated from field: repeated nodebase.v1.AdminServiceStatus services = 1;
   */
  services: AdminServiceStatus[];

  /**
   * @generated from field: int64 sampled_unix = 2;
   */
  sampledUnix: bigint;
};

/**
 * Describes the message nodebase.v1.AdminListServicesResponse.
 * Use `create(AdminListServicesResponseSchema)` to create a new message.
 */
export const AdminListServicesResponseSchema: GenMessage<AdminListServicesResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 2);

/**
 * @generated from message nodebase.v1.AdminInspectWorkerVMRequest
 */
export type AdminInspectWorkerVMRequest = Message<"nodebase.v1.AdminInspectWorkerVMRequest"> & {
  /**
   * @generated from field: string worker_id = 1;
   */
  workerId: string;
};

/**
 * Describes the message nodebase.v1.AdminInspectWorkerVMRequest.
 * Use `create(AdminInspectWorkerVMRequestSchema)` to create a new message.
 */
export const AdminInspectWorkerVMRequestSchema: GenMessage<AdminInspectWorkerVMRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 3);

/**
 * @generated from message nodebase.v1.AdminInspectWorkerVMResponse
 */
export type AdminInspectWorkerVMResponse = Message<"nodebase.v1.AdminInspectWorkerVMResponse"> & {
  /**
   * @generated from field: string worker_id = 1;
   */
  workerId: string;

  /**
   * @generated from field: string provider_object = 2;
   */
  providerObject: string;

  /**
   * @generated from field: uint64 generation = 3;
   */
  generation: bigint;

  /**
   * @generated from field: uint64 lease_epoch = 4;
   */
  leaseEpoch: bigint;

  /**
   * @generated from field: int64 observed_unix = 5;
   */
  observedUnix: bigint;

  /**
   * @generated from field: string vm_state = 6;
   */
  vmState: string;

  /**
   * @generated from field: string agent_state = 7;
   */
  agentState: string;

  /**
   * @generated from field: string firewall_state = 8;
   */
  firewallState: string;

  /**
   * @generated from field: string firewall_rules = 9;
   */
  firewallRules: string;

  /**
   * @generated from field: string firewall_config_sha256 = 10;
   */
  firewallConfigSha256: string;

  /**
   * @generated from field: bool disabled = 11;
   */
  disabled: boolean;

  /**
   * @generated from field: repeated string findings = 12;
   */
  findings: string[];

  /**
   * Only operations supported by this host for the observed authority.
   *
   * @generated from field: repeated string allowed_operations = 13;
   */
  allowedOperations: string[];

  /**
   * @generated from field: string transport_state = 14;
   */
  transportState: string;

  /**
   * @generated from field: string management_ssh_state = 15;
   */
  managementSshState: string;
};

/**
 * Describes the message nodebase.v1.AdminInspectWorkerVMResponse.
 * Use `create(AdminInspectWorkerVMResponseSchema)` to create a new message.
 */
export const AdminInspectWorkerVMResponseSchema: GenMessage<AdminInspectWorkerVMResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 4);

/**
 * @generated from message nodebase.v1.AdminManageWorkerVMRequest
 */
export type AdminManageWorkerVMRequest = Message<"nodebase.v1.AdminManageWorkerVMRequest"> & {
  /**
   * @generated from field: string worker_id = 1;
   */
  workerId: string;

  /**
   * restart-agent, reboot-vm or reapply-firewall; never a command or rule body.
   *
   * @generated from field: string operation = 2;
   */
  operation: string;

  /**
   * @generated from field: uint64 expected_generation = 3;
   */
  expectedGeneration: bigint;

  /**
   * @generated from field: uint64 expected_lease_epoch = 4;
   */
  expectedLeaseEpoch: bigint;
};

/**
 * Describes the message nodebase.v1.AdminManageWorkerVMRequest.
 * Use `create(AdminManageWorkerVMRequestSchema)` to create a new message.
 */
export const AdminManageWorkerVMRequestSchema: GenMessage<AdminManageWorkerVMRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 5);

/**
 * @generated from message nodebase.v1.AdminManageWorkerVMResponse
 */
export type AdminManageWorkerVMResponse = Message<"nodebase.v1.AdminManageWorkerVMResponse"> & {
  /**
   * @generated from field: bool accepted = 1;
   */
  accepted: boolean;
};

/**
 * Describes the message nodebase.v1.AdminManageWorkerVMResponse.
 * Use `create(AdminManageWorkerVMResponseSchema)` to create a new message.
 */
export const AdminManageWorkerVMResponseSchema: GenMessage<AdminManageWorkerVMResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 6);

/**
 * @generated from message nodebase.v1.AdminSetEdgeRolesRequest
 */
export type AdminSetEdgeRolesRequest = Message<"nodebase.v1.AdminSetEdgeRolesRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string edge_node_id = 2;
   */
  edgeNodeId: string;

  /**
   * @generated from field: repeated nodebase.v1.EdgeRole roles = 3;
   */
  roles: EdgeRole[];
};

/**
 * Describes the message nodebase.v1.AdminSetEdgeRolesRequest.
 * Use `create(AdminSetEdgeRolesRequestSchema)` to create a new message.
 */
export const AdminSetEdgeRolesRequestSchema: GenMessage<AdminSetEdgeRolesRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 7);

/**
 * @generated from message nodebase.v1.AdminSetEdgeRolesResponse
 */
export type AdminSetEdgeRolesResponse = Message<"nodebase.v1.AdminSetEdgeRolesResponse"> & {
  /**
   * @generated from field: nodebase.v1.EdgeNode edge = 1;
   */
  edge?: EdgeNode | undefined;
};

/**
 * Describes the message nodebase.v1.AdminSetEdgeRolesResponse.
 * Use `create(AdminSetEdgeRolesResponseSchema)` to create a new message.
 */
export const AdminSetEdgeRolesResponseSchema: GenMessage<AdminSetEdgeRolesResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 8);

/**
 * @generated from message nodebase.v1.AdminSetEdgeEndpointsRequest
 */
export type AdminSetEdgeEndpointsRequest = Message<"nodebase.v1.AdminSetEdgeEndpointsRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string edge_node_id = 2;
   */
  edgeNodeId: string;

  /**
   * @generated from field: repeated nodebase.v1.Endpoint endpoints = 3;
   */
  endpoints: Endpoint[];
};

/**
 * Describes the message nodebase.v1.AdminSetEdgeEndpointsRequest.
 * Use `create(AdminSetEdgeEndpointsRequestSchema)` to create a new message.
 */
export const AdminSetEdgeEndpointsRequestSchema: GenMessage<AdminSetEdgeEndpointsRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 9);

/**
 * @generated from message nodebase.v1.AdminSetEdgeEndpointsResponse
 */
export type AdminSetEdgeEndpointsResponse = Message<"nodebase.v1.AdminSetEdgeEndpointsResponse"> & {
  /**
   * @generated from field: nodebase.v1.EdgeNode edge = 1;
   */
  edge?: EdgeNode | undefined;
};

/**
 * Describes the message nodebase.v1.AdminSetEdgeEndpointsResponse.
 * Use `create(AdminSetEdgeEndpointsResponseSchema)` to create a new message.
 */
export const AdminSetEdgeEndpointsResponseSchema: GenMessage<AdminSetEdgeEndpointsResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 10);

/**
 * @generated from message nodebase.v1.AdminSetEdgeCapacityRequest
 */
export type AdminSetEdgeCapacityRequest = Message<"nodebase.v1.AdminSetEdgeCapacityRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string edge_node_id = 2;
   */
  edgeNodeId: string;

  /**
   * Authenticated carrier-session ceiling. Exit and Relay share this pool;
   * the Edge applies changes live without evicting admitted sessions.
   *
   * @generated from field: uint32 capacity = 3;
   */
  capacity: number;
};

/**
 * Describes the message nodebase.v1.AdminSetEdgeCapacityRequest.
 * Use `create(AdminSetEdgeCapacityRequestSchema)` to create a new message.
 */
export const AdminSetEdgeCapacityRequestSchema: GenMessage<AdminSetEdgeCapacityRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 11);

/**
 * @generated from message nodebase.v1.AdminSetEdgeCapacityResponse
 */
export type AdminSetEdgeCapacityResponse = Message<"nodebase.v1.AdminSetEdgeCapacityResponse"> & {
  /**
   * @generated from field: nodebase.v1.EdgeNode edge = 1;
   */
  edge?: EdgeNode | undefined;
};

/**
 * Describes the message nodebase.v1.AdminSetEdgeCapacityResponse.
 * Use `create(AdminSetEdgeCapacityResponseSchema)` to create a new message.
 */
export const AdminSetEdgeCapacityResponseSchema: GenMessage<AdminSetEdgeCapacityResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 12);

/**
 * @generated from message nodebase.v1.AdminSetWorkspaceEntitlementRequest
 */
export type AdminSetWorkspaceEntitlementRequest = Message<"nodebase.v1.AdminSetWorkspaceEntitlementRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;

  /**
   * Standardized capability key, never a commercial plan name. The first
   * Edge Exit rollout uses exit.regions with a comma-separated region list.
   *
   * @generated from field: string key = 3;
   */
  key: string;

  /**
   * empty deletes the entitlement
   *
   * @generated from field: string value = 4;
   */
  value: string;
};

/**
 * Describes the message nodebase.v1.AdminSetWorkspaceEntitlementRequest.
 * Use `create(AdminSetWorkspaceEntitlementRequestSchema)` to create a new message.
 */
export const AdminSetWorkspaceEntitlementRequestSchema: GenMessage<AdminSetWorkspaceEntitlementRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 13);

/**
 * @generated from message nodebase.v1.AdminSetWorkspaceEntitlementResponse
 */
export type AdminSetWorkspaceEntitlementResponse = Message<"nodebase.v1.AdminSetWorkspaceEntitlementResponse"> & {
};

/**
 * Describes the message nodebase.v1.AdminSetWorkspaceEntitlementResponse.
 * Use `create(AdminSetWorkspaceEntitlementResponseSchema)` to create a new message.
 */
export const AdminSetWorkspaceEntitlementResponseSchema: GenMessage<AdminSetWorkspaceEntitlementResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 14);

/**
 * @generated from message nodebase.v1.AdminCreateEdgeRequest
 */
export type AdminCreateEdgeRequest = Message<"nodebase.v1.AdminCreateEdgeRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string region = 2;
   */
  region: string;

  /**
   * @generated from field: repeated nodebase.v1.EdgeRole roles = 3;
   */
  roles: EdgeRole[];

  /**
   * @generated from field: repeated nodebase.v1.Endpoint endpoints = 4;
   */
  endpoints: Endpoint[];

  /**
   * @generated from field: uint32 capacity = 5;
   */
  capacity: number;
};

/**
 * Describes the message nodebase.v1.AdminCreateEdgeRequest.
 * Use `create(AdminCreateEdgeRequestSchema)` to create a new message.
 */
export const AdminCreateEdgeRequestSchema: GenMessage<AdminCreateEdgeRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 15);

/**
 * @generated from message nodebase.v1.AdminCreateEdgeResponse
 */
export type AdminCreateEdgeResponse = Message<"nodebase.v1.AdminCreateEdgeResponse"> & {
  /**
   * @generated from field: nodebase.v1.EdgeNode edge = 1;
   */
  edge?: EdgeNode | undefined;

  /**
   * Plaintext is returned once; only its hash is stored.
   *
   * @generated from field: string bootstrap_token = 2;
   */
  bootstrapToken: string;
};

/**
 * Describes the message nodebase.v1.AdminCreateEdgeResponse.
 * Use `create(AdminCreateEdgeResponseSchema)` to create a new message.
 */
export const AdminCreateEdgeResponseSchema: GenMessage<AdminCreateEdgeResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 16);

/**
 * @generated from message nodebase.v1.AdminListEdgesRequest
 */
export type AdminListEdgesRequest = Message<"nodebase.v1.AdminListEdgesRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;
};

/**
 * Describes the message nodebase.v1.AdminListEdgesRequest.
 * Use `create(AdminListEdgesRequestSchema)` to create a new message.
 */
export const AdminListEdgesRequestSchema: GenMessage<AdminListEdgesRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 17);

/**
 * @generated from message nodebase.v1.AdminEdge
 */
export type AdminEdge = Message<"nodebase.v1.AdminEdge"> & {
  /**
   * @generated from field: nodebase.v1.EdgeNode edge = 1;
   */
  edge?: EdgeNode | undefined;

  /**
   * @generated from field: repeated nodebase.v1.EdgeAssignment assignments = 2;
   */
  assignments: EdgeAssignment[];
};

/**
 * Describes the message nodebase.v1.AdminEdge.
 * Use `create(AdminEdgeSchema)` to create a new message.
 */
export const AdminEdgeSchema: GenMessage<AdminEdge> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 18);

/**
 * @generated from message nodebase.v1.AdminListEdgesResponse
 */
export type AdminListEdgesResponse = Message<"nodebase.v1.AdminListEdgesResponse"> & {
  /**
   * @generated from field: repeated nodebase.v1.AdminEdge edges = 1;
   */
  edges: AdminEdge[];
};

/**
 * Describes the message nodebase.v1.AdminListEdgesResponse.
 * Use `create(AdminListEdgesResponseSchema)` to create a new message.
 */
export const AdminListEdgesResponseSchema: GenMessage<AdminListEdgesResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 19);

/**
 * @generated from message nodebase.v1.AdminSetEdgeAssignmentRequest
 */
export type AdminSetEdgeAssignmentRequest = Message<"nodebase.v1.AdminSetEdgeAssignmentRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;

  /**
   * @generated from field: nodebase.v1.EdgeRole role = 3;
   */
  role: EdgeRole;

  /**
   * @generated from field: string region = 4;
   */
  region: string;

  /**
   * Legacy singleton field. Empty clears only when edge_node_ids is also empty.
   *
   * @generated from field: string edge_node_id = 5;
   */
  edgeNodeId: string;

  /**
   * When non-empty, this is the complete desired Edge set for the role. Relay
   * accepts multiple candidates in preference order; Exit remains singular.
   * edge_node_id/region above are retained for backwards-compatible singleton
   * calls and must not be combined with this field.
   *
   * @generated from field: repeated string edge_node_ids = 6;
   */
  edgeNodeIds: string[];
};

/**
 * Describes the message nodebase.v1.AdminSetEdgeAssignmentRequest.
 * Use `create(AdminSetEdgeAssignmentRequestSchema)` to create a new message.
 */
export const AdminSetEdgeAssignmentRequestSchema: GenMessage<AdminSetEdgeAssignmentRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 20);

/**
 * @generated from message nodebase.v1.AdminSetEdgeAssignmentResponse
 */
export type AdminSetEdgeAssignmentResponse = Message<"nodebase.v1.AdminSetEdgeAssignmentResponse"> & {
  /**
   * absent when cleared
   *
   * @generated from field: nodebase.v1.EdgeAssignment assignment = 1;
   */
  assignment?: EdgeAssignment | undefined;

  /**
   * @generated from field: repeated nodebase.v1.EdgeAssignment assignments = 2;
   */
  assignments: EdgeAssignment[];
};

/**
 * Describes the message nodebase.v1.AdminSetEdgeAssignmentResponse.
 * Use `create(AdminSetEdgeAssignmentResponseSchema)` to create a new message.
 */
export const AdminSetEdgeAssignmentResponseSchema: GenMessage<AdminSetEdgeAssignmentResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 21);

/**
 * @generated from message nodebase.v1.AdminRevokeEdgeRequest
 */
export type AdminRevokeEdgeRequest = Message<"nodebase.v1.AdminRevokeEdgeRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string edge_node_id = 2;
   */
  edgeNodeId: string;
};

/**
 * Describes the message nodebase.v1.AdminRevokeEdgeRequest.
 * Use `create(AdminRevokeEdgeRequestSchema)` to create a new message.
 */
export const AdminRevokeEdgeRequestSchema: GenMessage<AdminRevokeEdgeRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 22);

/**
 * @generated from message nodebase.v1.AdminRevokeEdgeResponse
 */
export type AdminRevokeEdgeResponse = Message<"nodebase.v1.AdminRevokeEdgeResponse"> & {
};

/**
 * Describes the message nodebase.v1.AdminRevokeEdgeResponse.
 * Use `create(AdminRevokeEdgeResponseSchema)` to create a new message.
 */
export const AdminRevokeEdgeResponseSchema: GenMessage<AdminRevokeEdgeResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 23);

/**
 * AdminAccount is one row of the account overview.
 *
 * @generated from message nodebase.v1.AdminAccount
 */
export type AdminAccount = Message<"nodebase.v1.AdminAccount"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: int64 created_unix = 3;
   */
  createdUnix: bigint;

  /**
   * @generated from field: int32 workspace_count = 4;
   */
  workspaceCount: number;

  /**
   * @generated from field: int32 worker_count = 5;
   */
  workerCount: number;

  /**
   * @generated from field: int32 device_count = 6;
   */
  deviceCount: number;

  /**
   * The account's default workspace: the target an operator provisions into
   * now that CreateWorker is operator-only.
   *
   * @generated from field: string default_workspace_id = 7;
   */
  defaultWorkspaceId: string;

  /**
   * Current exit.regions value for the default Workspace; empty means off.
   *
   * @generated from field: string exit_regions = 8;
   */
  exitRegions: string;

  /**
   * Last time one of the account's non-revoked Devices fetched authoritative
   * state. A Worker heartbeat is deliberately not account activity: Workers
   * stay online while their owners are away.
   *
   * @generated from field: int64 last_active_unix = 9;
   */
  lastActiveUnix: bigint;

  /**
   * Complete 30-day egress total: Worker-native egress plus Managed Edge Exit.
   * Destination data is not joined to either figure.
   *
   * @generated from field: int64 traffic_30d_up_bytes = 10;
   */
  traffic30dUpBytes: bigint;

  /**
   * @generated from field: int64 traffic_30d_down_bytes = 11;
   */
  traffic30dDownBytes: bigint;

  /**
   * @generated from field: int64 traffic_30d_connections = 12;
   */
  traffic30dConnections: bigint;

  /**
   * Authoritative monthly Managed Edge Exit ceiling for the default
   * Workspace. This is the configured quota, not traffic observed in an
   * overlapping 30-day window.
   *
   * @generated from field: uint64 exit_quota_bytes = 13;
   */
  exitQuotaBytes: bigint;

  /**
   * Credit already issued to each region and still available for new flows in
   * the current UTC month. Credit is intentionally reported separately from
   * the quota: Control grants it in bounded chunks and cannot reclaim an
   * unused chunk from another Edge mid-month.
   *
   * @generated from field: repeated nodebase.v1.AdminEdgeExitCredit exit_credits = 14;
   */
  exitCredits: AdminEdgeExitCredit[];

  /**
   * @generated from field: nodebase.v1.AccountCohort cohort = 15;
   */
  cohort: AccountCohort;

  /**
   * @generated from field: uint64 cohort_revision = 16;
   */
  cohortRevision: bigint;
};

/**
 * Describes the message nodebase.v1.AdminAccount.
 * Use `create(AdminAccountSchema)` to create a new message.
 */
export const AdminAccountSchema: GenMessage<AdminAccount> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 24);

/**
 * @generated from message nodebase.v1.AdminAccountCohortChange
 */
export type AdminAccountCohortChange = Message<"nodebase.v1.AdminAccountCohortChange"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: nodebase.v1.AccountCohort cohort = 2;
   */
  cohort: AccountCohort;

  /**
   * @generated from field: uint64 expected_revision = 3;
   */
  expectedRevision: bigint;
};

/**
 * Describes the message nodebase.v1.AdminAccountCohortChange.
 * Use `create(AdminAccountCohortChangeSchema)` to create a new message.
 */
export const AdminAccountCohortChangeSchema: GenMessage<AdminAccountCohortChange> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 25);

/**
 * @generated from message nodebase.v1.AdminSetAccountCohortsRequest
 */
export type AdminSetAccountCohortsRequest = Message<"nodebase.v1.AdminSetAccountCohortsRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: repeated nodebase.v1.AdminAccountCohortChange changes = 2;
   */
  changes: AdminAccountCohortChange[];

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message nodebase.v1.AdminSetAccountCohortsRequest.
 * Use `create(AdminSetAccountCohortsRequestSchema)` to create a new message.
 */
export const AdminSetAccountCohortsRequestSchema: GenMessage<AdminSetAccountCohortsRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 26);

/**
 * @generated from message nodebase.v1.AdminSetAccountCohortsResponse
 */
export type AdminSetAccountCohortsResponse = Message<"nodebase.v1.AdminSetAccountCohortsResponse"> & {
  /**
   * @generated from field: bool applied = 1;
   */
  applied: boolean;

  /**
   * @generated from field: repeated nodebase.v1.AdminAccount accounts = 2;
   */
  accounts: AdminAccount[];

  /**
   * @generated from field: repeated string conflict_account_ids = 3;
   */
  conflictAccountIds: string[];
};

/**
 * Describes the message nodebase.v1.AdminSetAccountCohortsResponse.
 * Use `create(AdminSetAccountCohortsResponseSchema)` to create a new message.
 */
export const AdminSetAccountCohortsResponseSchema: GenMessage<AdminSetAccountCohortsResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 27);

/**
 * @generated from message nodebase.v1.FeatureRollout
 */
export type FeatureRollout = Message<"nodebase.v1.FeatureRollout"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: nodebase.v1.FeatureRolloutStage stage = 2;
   */
  stage: FeatureRolloutStage;

  /**
   * @generated from field: uint64 revision = 3;
   */
  revision: bigint;

  /**
   * @generated from field: int64 updated_unix = 4;
   */
  updatedUnix: bigint;

  /**
   * @generated from field: string updated_by_account_id = 5;
   */
  updatedByAccountId: string;

  /**
   * @generated from field: string reason = 6;
   */
  reason: string;
};

/**
 * Describes the message nodebase.v1.FeatureRollout.
 * Use `create(FeatureRolloutSchema)` to create a new message.
 */
export const FeatureRolloutSchema: GenMessage<FeatureRollout> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 28);

/**
 * @generated from message nodebase.v1.WorkspaceFeatureOverride
 */
export type WorkspaceFeatureOverride = Message<"nodebase.v1.WorkspaceFeatureOverride"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * @generated from field: nodebase.v1.WorkspaceFeatureOverrideMode mode = 3;
   */
  mode: WorkspaceFeatureOverrideMode;

  /**
   * @generated from field: uint64 revision = 4;
   */
  revision: bigint;

  /**
   * @generated from field: int64 updated_unix = 5;
   */
  updatedUnix: bigint;

  /**
   * @generated from field: string updated_by_account_id = 6;
   */
  updatedByAccountId: string;

  /**
   * @generated from field: string reason = 7;
   */
  reason: string;
};

/**
 * Describes the message nodebase.v1.WorkspaceFeatureOverride.
 * Use `create(WorkspaceFeatureOverrideSchema)` to create a new message.
 */
export const WorkspaceFeatureOverrideSchema: GenMessage<WorkspaceFeatureOverride> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 29);

/**
 * @generated from message nodebase.v1.AdminListFeatureRolloutsRequest
 */
export type AdminListFeatureRolloutsRequest = Message<"nodebase.v1.AdminListFeatureRolloutsRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;
};

/**
 * Describes the message nodebase.v1.AdminListFeatureRolloutsRequest.
 * Use `create(AdminListFeatureRolloutsRequestSchema)` to create a new message.
 */
export const AdminListFeatureRolloutsRequestSchema: GenMessage<AdminListFeatureRolloutsRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 30);

/**
 * @generated from message nodebase.v1.AdminListFeatureRolloutsResponse
 */
export type AdminListFeatureRolloutsResponse = Message<"nodebase.v1.AdminListFeatureRolloutsResponse"> & {
  /**
   * @generated from field: repeated nodebase.v1.FeatureRollout rollouts = 1;
   */
  rollouts: FeatureRollout[];

  /**
   * @generated from field: repeated nodebase.v1.WorkspaceFeatureOverride workspace_overrides = 2;
   */
  workspaceOverrides: WorkspaceFeatureOverride[];
};

/**
 * Describes the message nodebase.v1.AdminListFeatureRolloutsResponse.
 * Use `create(AdminListFeatureRolloutsResponseSchema)` to create a new message.
 */
export const AdminListFeatureRolloutsResponseSchema: GenMessage<AdminListFeatureRolloutsResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 31);

/**
 * @generated from message nodebase.v1.AdminSetFeatureRolloutRequest
 */
export type AdminSetFeatureRolloutRequest = Message<"nodebase.v1.AdminSetFeatureRolloutRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * @generated from field: nodebase.v1.FeatureRolloutStage stage = 3;
   */
  stage: FeatureRolloutStage;

  /**
   * @generated from field: uint64 expected_revision = 4;
   */
  expectedRevision: bigint;

  /**
   * @generated from field: string reason = 5;
   */
  reason: string;
};

/**
 * Describes the message nodebase.v1.AdminSetFeatureRolloutRequest.
 * Use `create(AdminSetFeatureRolloutRequestSchema)` to create a new message.
 */
export const AdminSetFeatureRolloutRequestSchema: GenMessage<AdminSetFeatureRolloutRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 32);

/**
 * @generated from message nodebase.v1.AdminSetFeatureRolloutResponse
 */
export type AdminSetFeatureRolloutResponse = Message<"nodebase.v1.AdminSetFeatureRolloutResponse"> & {
  /**
   * @generated from field: bool applied = 1;
   */
  applied: boolean;

  /**
   * @generated from field: nodebase.v1.FeatureRollout rollout = 2;
   */
  rollout?: FeatureRollout | undefined;
};

/**
 * Describes the message nodebase.v1.AdminSetFeatureRolloutResponse.
 * Use `create(AdminSetFeatureRolloutResponseSchema)` to create a new message.
 */
export const AdminSetFeatureRolloutResponseSchema: GenMessage<AdminSetFeatureRolloutResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 33);

/**
 * @generated from message nodebase.v1.AdminSetWorkspaceFeatureOverrideRequest
 */
export type AdminSetWorkspaceFeatureOverrideRequest = Message<"nodebase.v1.AdminSetWorkspaceFeatureOverrideRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;

  /**
   * @generated from field: string key = 3;
   */
  key: string;

  /**
   * @generated from field: nodebase.v1.WorkspaceFeatureOverrideMode mode = 4;
   */
  mode: WorkspaceFeatureOverrideMode;

  /**
   * @generated from field: uint64 expected_revision = 5;
   */
  expectedRevision: bigint;

  /**
   * @generated from field: string reason = 6;
   */
  reason: string;
};

/**
 * Describes the message nodebase.v1.AdminSetWorkspaceFeatureOverrideRequest.
 * Use `create(AdminSetWorkspaceFeatureOverrideRequestSchema)` to create a new message.
 */
export const AdminSetWorkspaceFeatureOverrideRequestSchema: GenMessage<AdminSetWorkspaceFeatureOverrideRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 34);

/**
 * @generated from message nodebase.v1.AdminSetWorkspaceFeatureOverrideResponse
 */
export type AdminSetWorkspaceFeatureOverrideResponse = Message<"nodebase.v1.AdminSetWorkspaceFeatureOverrideResponse"> & {
  /**
   * @generated from field: bool applied = 1;
   */
  applied: boolean;

  /**
   * @generated from field: nodebase.v1.WorkspaceFeatureOverride workspace_override = 2;
   */
  workspaceOverride?: WorkspaceFeatureOverride | undefined;
};

/**
 * Describes the message nodebase.v1.AdminSetWorkspaceFeatureOverrideResponse.
 * Use `create(AdminSetWorkspaceFeatureOverrideResponseSchema)` to create a new message.
 */
export const AdminSetWorkspaceFeatureOverrideResponseSchema: GenMessage<AdminSetWorkspaceFeatureOverrideResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 35);

/**
 * @generated from message nodebase.v1.AdminFeatureAuditEntry
 */
export type AdminFeatureAuditEntry = Message<"nodebase.v1.AdminFeatureAuditEntry"> & {
  /**
   * @generated from field: uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 created_unix = 2;
   */
  createdUnix: bigint;

  /**
   * @generated from field: string actor_account_id = 3;
   */
  actorAccountId: string;

  /**
   * @generated from field: string action = 4;
   */
  action: string;

  /**
   * @generated from field: string key = 5;
   */
  key: string;

  /**
   * @generated from field: string target_account_id = 6;
   */
  targetAccountId: string;

  /**
   * @generated from field: string workspace_id = 7;
   */
  workspaceId: string;

  /**
   * @generated from field: string previous_value = 8;
   */
  previousValue: string;

  /**
   * @generated from field: string new_value = 9;
   */
  newValue: string;

  /**
   * @generated from field: string reason = 10;
   */
  reason: string;

  /**
   * @generated from field: string request_id = 11;
   */
  requestId: string;

  /**
   * @generated from field: uint64 revision = 12;
   */
  revision: bigint;
};

/**
 * Describes the message nodebase.v1.AdminFeatureAuditEntry.
 * Use `create(AdminFeatureAuditEntrySchema)` to create a new message.
 */
export const AdminFeatureAuditEntrySchema: GenMessage<AdminFeatureAuditEntry> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 36);

/**
 * @generated from message nodebase.v1.AdminListFeatureAuditRequest
 */
export type AdminListFeatureAuditRequest = Message<"nodebase.v1.AdminListFeatureAuditRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: uint32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message nodebase.v1.AdminListFeatureAuditRequest.
 * Use `create(AdminListFeatureAuditRequestSchema)` to create a new message.
 */
export const AdminListFeatureAuditRequestSchema: GenMessage<AdminListFeatureAuditRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 37);

/**
 * @generated from message nodebase.v1.AdminListFeatureAuditResponse
 */
export type AdminListFeatureAuditResponse = Message<"nodebase.v1.AdminListFeatureAuditResponse"> & {
  /**
   * @generated from field: repeated nodebase.v1.AdminFeatureAuditEntry entries = 1;
   */
  entries: AdminFeatureAuditEntry[];
};

/**
 * Describes the message nodebase.v1.AdminListFeatureAuditResponse.
 * Use `create(AdminListFeatureAuditResponseSchema)` to create a new message.
 */
export const AdminListFeatureAuditResponseSchema: GenMessage<AdminListFeatureAuditResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 38);

/**
 * @generated from message nodebase.v1.AdminEdgeExitCredit
 */
export type AdminEdgeExitCredit = Message<"nodebase.v1.AdminEdgeExitCredit"> & {
  /**
   * @generated from field: string region = 1;
   */
  region: string;

  /**
   * @generated from field: uint64 available_bytes = 2;
   */
  availableBytes: bigint;
};

/**
 * Describes the message nodebase.v1.AdminEdgeExitCredit.
 * Use `create(AdminEdgeExitCreditSchema)` to create a new message.
 */
export const AdminEdgeExitCreditSchema: GenMessage<AdminEdgeExitCredit> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 39);

/**
 * @generated from message nodebase.v1.AdminListAccountsRequest
 */
export type AdminListAccountsRequest = Message<"nodebase.v1.AdminListAccountsRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;
};

/**
 * Describes the message nodebase.v1.AdminListAccountsRequest.
 * Use `create(AdminListAccountsRequestSchema)` to create a new message.
 */
export const AdminListAccountsRequestSchema: GenMessage<AdminListAccountsRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 40);

/**
 * @generated from message nodebase.v1.AdminListAccountsResponse
 */
export type AdminListAccountsResponse = Message<"nodebase.v1.AdminListAccountsResponse"> & {
  /**
   * @generated from field: repeated nodebase.v1.AdminAccount accounts = 1;
   */
  accounts: AdminAccount[];
};

/**
 * Describes the message nodebase.v1.AdminListAccountsResponse.
 * Use `create(AdminListAccountsResponseSchema)` to create a new message.
 */
export const AdminListAccountsResponseSchema: GenMessage<AdminListAccountsResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 41);

/**
 * AdminWorker pairs a worker with its owner for the fleet overview.
 *
 * @generated from message nodebase.v1.AdminWorker
 */
export type AdminWorker = Message<"nodebase.v1.AdminWorker"> & {
  /**
   * @generated from field: nodebase.v1.Worker worker = 1;
   */
  worker?: Worker | undefined;

  /**
   * @generated from field: string owner_email = 2;
   */
  ownerEmail: string;

  /**
   * Last WG counters the agent reported (cumulative since interface up);
   * coarse egress accounting for the global routing mode.
   *
   * @generated from field: uint64 wg_rx_bytes = 3;
   */
  wgRxBytes: bigint;

  /**
   * @generated from field: uint64 wg_tx_bytes = 4;
   */
  wgTxBytes: bigint;

  /**
   * @generated from field: int64 traffic_reported_unix = 5;
   */
  trafficReportedUnix: bigint;

  /**
   * The workspace's assigned exit IP; empty means the default egress.
   *
   * @generated from field: string exit_ip = 6;
   */
  exitIp: string;

  /**
   * True only for a container whose source address differs from the binding.
   * Native VM exit rules update live and never require a container rebuild.
   *
   * @generated from field: bool exit_pending_rebuild = 7;
   */
  exitPendingRebuild: boolean;

  /**
   * Live tunnel rate in bytes per second, derived from consecutive heartbeat
   * samples (~30s resolution); -1 when unknowable (first report, counter
   * reset, stale gap). The operator's "who is on the link right now" view.
   *
   * @generated from field: int64 wg_rx_rate_bytes_sec = 8;
   */
  wgRxRateBytesSec: bigint;

  /**
   * @generated from field: int64 wg_tx_rate_bytes_sec = 9;
   */
  wgTxRateBytesSec: bigint;

  /**
   * Latest authenticated Worker resource snapshot. CPU is percent of the
   * Worker's enforced quota; memory/disk are used MB. This is deliberately
   * latest-only operational state, not a historical metrics series.
   *
   * @generated from field: double cpu_pct = 19;
   */
  cpuPct: number;

  /**
   * @generated from field: uint64 mem_used_mb = 20;
   */
  memUsedMb: bigint;

  /**
   * @generated from field: uint64 disk_used_mb = 21;
   */
  diskUsedMb: bigint;

  /**
   * @generated from field: int64 resource_reported_unix = 22;
   */
  resourceReportedUnix: bigint;

  /**
   * Recorded Worker runtime (native-vm, kata-clh, runsc, runc); empty when unknown.
   *
   * @generated from field: string runtime = 23;
   */
  runtime: string;

  /**
   * Container rebuild target from the default/canary policy. For native VMs
   * this is native-vm; it does not represent a queued runtime migration.
   *
   * @generated from field: string desired_runtime = 24;
   */
  desiredRuntime: string;

  /**
   * @generated from field: string tier = 25;
   */
  tier: string;

  /**
   * @generated from field: nodebase.v1.WorkerTierChange tier_change = 26;
   */
  tierChange?: WorkerTierChange | undefined;
};

/**
 * Describes the message nodebase.v1.AdminWorker.
 * Use `create(AdminWorkerSchema)` to create a new message.
 */
export const AdminWorkerSchema: GenMessage<AdminWorker> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 42);

/**
 * @generated from message nodebase.v1.AdminListWorkersRequest
 */
export type AdminListWorkersRequest = Message<"nodebase.v1.AdminListWorkersRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;
};

/**
 * Describes the message nodebase.v1.AdminListWorkersRequest.
 * Use `create(AdminListWorkersRequestSchema)` to create a new message.
 */
export const AdminListWorkersRequestSchema: GenMessage<AdminListWorkersRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 43);

/**
 * @generated from message nodebase.v1.AdminListWorkersResponse
 */
export type AdminListWorkersResponse = Message<"nodebase.v1.AdminListWorkersResponse"> & {
  /**
   * @generated from field: repeated nodebase.v1.AdminWorker workers = 1;
   */
  workers: AdminWorker[];

  /**
   * The dedicated exit IPs this host can bind (NODEBASE_EXIT_IPS), so the
   * console offers a picker instead of a typed address. Empty means the
   * binding surface is closed.
   *
   * @generated from field: repeated string exit_ip_pool = 2;
   */
  exitIpPool: string[];

  /**
   * The host's link capacity in Mbps (NODEBASE_LINK_MBPS), so the live view
   * can show utilization against the real ceiling. 0 = not configured.
   *
   * @generated from field: int32 link_mbps = 3;
   */
  linkMbps: number;

  /**
   * @generated from field: repeated nodebase.v1.WorkerTier tiers = 4;
   */
  tiers: WorkerTier[];
};

/**
 * Describes the message nodebase.v1.AdminListWorkersResponse.
 * Use `create(AdminListWorkersResponseSchema)` to create a new message.
 */
export const AdminListWorkersResponseSchema: GenMessage<AdminListWorkersResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 44);

/**
 * AdminDevice pairs a device with its owner, same shape as AdminWorker.
 *
 * @generated from message nodebase.v1.AdminDevice
 */
export type AdminDevice = Message<"nodebase.v1.AdminDevice"> & {
  /**
   * @generated from field: nodebase.v1.Device device = 1;
   */
  device?: Device | undefined;

  /**
   * @generated from field: string owner_email = 2;
   */
  ownerEmail: string;

  /**
   * @generated from field: repeated nodebase.v1.AdminPrivateOverlayLane private_lanes = 3;
   */
  privateLanes: AdminPrivateOverlayLane[];
};

/**
 * Describes the message nodebase.v1.AdminDevice.
 * Use `create(AdminDeviceSchema)` to create a new message.
 */
export const AdminDeviceSchema: GenMessage<AdminDevice> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 45);

/**
 * @generated from message nodebase.v1.AdminPrivateOverlayLane
 */
export type AdminPrivateOverlayLane = Message<"nodebase.v1.AdminPrivateOverlayLane"> & {
  /**
   * @generated from field: nodebase.v1.PrivateOverlayLane lane = 1;
   */
  lane?: PrivateOverlayLane | undefined;

  /**
   * @generated from field: int64 wg_handshake_unix = 2;
   */
  wgHandshakeUnix: bigint;

  /**
   * @generated from field: uint64 wg_rx_bytes = 3;
   */
  wgRxBytes: bigint;

  /**
   * @generated from field: uint64 wg_tx_bytes = 4;
   */
  wgTxBytes: bigint;

  /**
   * @generated from field: string wg_endpoint = 5;
   */
  wgEndpoint: string;

  /**
   * @generated from field: int64 wg_reported_unix = 6;
   */
  wgReportedUnix: bigint;
};

/**
 * Describes the message nodebase.v1.AdminPrivateOverlayLane.
 * Use `create(AdminPrivateOverlayLaneSchema)` to create a new message.
 */
export const AdminPrivateOverlayLaneSchema: GenMessage<AdminPrivateOverlayLane> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 46);

/**
 * @generated from message nodebase.v1.AdminListDevicesRequest
 */
export type AdminListDevicesRequest = Message<"nodebase.v1.AdminListDevicesRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;
};

/**
 * Describes the message nodebase.v1.AdminListDevicesRequest.
 * Use `create(AdminListDevicesRequestSchema)` to create a new message.
 */
export const AdminListDevicesRequestSchema: GenMessage<AdminListDevicesRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 47);

/**
 * @generated from message nodebase.v1.AdminListDevicesResponse
 */
export type AdminListDevicesResponse = Message<"nodebase.v1.AdminListDevicesResponse"> & {
  /**
   * @generated from field: repeated nodebase.v1.AdminDevice devices = 1;
   */
  devices: AdminDevice[];
};

/**
 * Describes the message nodebase.v1.AdminListDevicesResponse.
 * Use `create(AdminListDevicesResponseSchema)` to create a new message.
 */
export const AdminListDevicesResponseSchema: GenMessage<AdminListDevicesResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 48);

/**
 * @generated from message nodebase.v1.AdminSetDevicePrivateLaneCountRequest
 */
export type AdminSetDevicePrivateLaneCountRequest = Message<"nodebase.v1.AdminSetDevicePrivateLaneCountRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string device_id = 2;
   */
  deviceId: string;

  /**
   * exactly 1 or 2
   *
   * @generated from field: uint32 desired_count = 3;
   */
  desiredCount: number;
};

/**
 * Describes the message nodebase.v1.AdminSetDevicePrivateLaneCountRequest.
 * Use `create(AdminSetDevicePrivateLaneCountRequestSchema)` to create a new message.
 */
export const AdminSetDevicePrivateLaneCountRequestSchema: GenMessage<AdminSetDevicePrivateLaneCountRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 49);

/**
 * @generated from message nodebase.v1.AdminSetDevicePrivateLaneCountResponse
 */
export type AdminSetDevicePrivateLaneCountResponse = Message<"nodebase.v1.AdminSetDevicePrivateLaneCountResponse"> & {
  /**
   * @generated from field: nodebase.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message nodebase.v1.AdminSetDevicePrivateLaneCountResponse.
 * Use `create(AdminSetDevicePrivateLaneCountResponseSchema)` to create a new message.
 */
export const AdminSetDevicePrivateLaneCountResponseSchema: GenMessage<AdminSetDevicePrivateLaneCountResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 50);

/**
 * @generated from message nodebase.v1.AdminCreateInvitesRequest
 */
export type AdminCreateInvitesRequest = Message<"nodebase.v1.AdminCreateInvitesRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * how many codes to mint
   *
   * @generated from field: int32 count = 2;
   */
  count: number;

  /**
   * what they are for; shown in the listing
   *
   * @generated from field: string note = 3;
   */
  note: string;

  /**
   * accounts each code may create; 0 means 1
   *
   * @generated from field: int32 max_uses = 4;
   */
  maxUses: number;

  /**
   * 0 means never
   *
   * @generated from field: int32 expires_days = 5;
   */
  expiresDays: number;
};

/**
 * Describes the message nodebase.v1.AdminCreateInvitesRequest.
 * Use `create(AdminCreateInvitesRequestSchema)` to create a new message.
 */
export const AdminCreateInvitesRequestSchema: GenMessage<AdminCreateInvitesRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 51);

/**
 * @generated from message nodebase.v1.AdminCreateInvitesResponse
 */
export type AdminCreateInvitesResponse = Message<"nodebase.v1.AdminCreateInvitesResponse"> & {
  /**
   * The plaintext codes, returned exactly once — only hashes are stored, so
   * this response is the sole copy. Same contract as a bootstrap token.
   *
   * @generated from field: repeated string codes = 1;
   */
  codes: string[];
};

/**
 * Describes the message nodebase.v1.AdminCreateInvitesResponse.
 * Use `create(AdminCreateInvitesResponseSchema)` to create a new message.
 */
export const AdminCreateInvitesResponseSchema: GenMessage<AdminCreateInvitesResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 52);

/**
 * @generated from message nodebase.v1.AdminListInvitesRequest
 */
export type AdminListInvitesRequest = Message<"nodebase.v1.AdminListInvitesRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;
};

/**
 * Describes the message nodebase.v1.AdminListInvitesRequest.
 * Use `create(AdminListInvitesRequestSchema)` to create a new message.
 */
export const AdminListInvitesRequestSchema: GenMessage<AdminListInvitesRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 53);

/**
 * AdminInvite is one invite's state. It carries no code: they are stored
 * hashed, so a listing cannot show them however convenient that would be.
 *
 * @generated from message nodebase.v1.AdminInvite
 */
export type AdminInvite = Message<"nodebase.v1.AdminInvite"> & {
  /**
   * @generated from field: string note = 1;
   */
  note: string;

  /**
   * @generated from field: int32 max_uses = 2;
   */
  maxUses: number;

  /**
   * @generated from field: int32 used_count = 3;
   */
  usedCount: number;

  /**
   * 0 = never
   *
   * @generated from field: int64 expires_unix = 4;
   */
  expiresUnix: bigint;

  /**
   * @generated from field: int64 created_unix = 5;
   */
  createdUnix: bigint;

  /**
   * emails
   *
   * @generated from field: repeated string redeemed_by = 6;
   */
  redeemedBy: string[];
};

/**
 * Describes the message nodebase.v1.AdminInvite.
 * Use `create(AdminInviteSchema)` to create a new message.
 */
export const AdminInviteSchema: GenMessage<AdminInvite> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 54);

/**
 * @generated from message nodebase.v1.AdminListInvitesResponse
 */
export type AdminListInvitesResponse = Message<"nodebase.v1.AdminListInvitesResponse"> & {
  /**
   * @generated from field: repeated nodebase.v1.AdminInvite invites = 1;
   */
  invites: AdminInvite[];
};

/**
 * Describes the message nodebase.v1.AdminListInvitesResponse.
 * Use `create(AdminListInvitesResponseSchema)` to create a new message.
 */
export const AdminListInvitesResponseSchema: GenMessage<AdminListInvitesResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 55);

/**
 * @generated from message nodebase.v1.AdminSetWorkerSpecRequest
 */
export type AdminSetWorkerSpecRequest = Message<"nodebase.v1.AdminSetWorkerSpecRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string worker_id = 2;
   */
  workerId: string;

  /**
   * The complete spec the worker should have, not a delta: all three fields
   * are required, and each must be at or above the Lite Worker baseline.
   *
   * @generated from field: nodebase.v1.WorkerSpec spec = 3;
   */
  spec?: WorkerSpec | undefined;
};

/**
 * Describes the message nodebase.v1.AdminSetWorkerSpecRequest.
 * Use `create(AdminSetWorkerSpecRequestSchema)` to create a new message.
 */
export const AdminSetWorkerSpecRequestSchema: GenMessage<AdminSetWorkerSpecRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 56);

/**
 * @generated from message nodebase.v1.AdminSetWorkerSpecResponse
 */
export type AdminSetWorkerSpecResponse = Message<"nodebase.v1.AdminSetWorkerSpecResponse"> & {
  /**
   * The worker as it now stands, spec included.
   *
   * @generated from field: nodebase.v1.Worker worker = 1;
   */
  worker?: Worker | undefined;
};

/**
 * Describes the message nodebase.v1.AdminSetWorkerSpecResponse.
 * Use `create(AdminSetWorkerSpecResponseSchema)` to create a new message.
 */
export const AdminSetWorkerSpecResponseSchema: GenMessage<AdminSetWorkerSpecResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 57);

/**
 * @generated from message nodebase.v1.AdminSetExitBindingRequest
 */
export type AdminSetExitBindingRequest = Message<"nodebase.v1.AdminSetExitBindingRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;

  /**
   * The exit IP to assign, from the host's configured pool
   * (NODEBASE_EXIT_IPS). Empty clears the assignment and the workspace
   * returns to the default egress for new connections.
   *
   * @generated from field: string exit_ip = 3;
   */
  exitIp: string;

  /**
   * @generated from field: string note = 4;
   */
  note: string;
};

/**
 * Describes the message nodebase.v1.AdminSetExitBindingRequest.
 * Use `create(AdminSetExitBindingRequestSchema)` to create a new message.
 */
export const AdminSetExitBindingRequestSchema: GenMessage<AdminSetExitBindingRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 58);

/**
 * @generated from message nodebase.v1.AdminSetExitBindingResponse
 */
export type AdminSetExitBindingResponse = Message<"nodebase.v1.AdminSetExitBindingResponse"> & {
  /**
   * Reserved container source address retained for container compatibility;
   * native VMs use their own guest addresses. Empty when the binding is cleared.
   *
   * @generated from field: string container_ip = 1;
   */
  containerIp: string;

  /**
   * True when a live container needs the reserved source address on rebuild.
   * Native VMs update their exit rules live and do not set this flag.
   *
   * @generated from field: bool rebuild_required = 2;
   */
  rebuildRequired: boolean;
};

/**
 * Describes the message nodebase.v1.AdminSetExitBindingResponse.
 * Use `create(AdminSetExitBindingResponseSchema)` to create a new message.
 */
export const AdminSetExitBindingResponseSchema: GenMessage<AdminSetExitBindingResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 59);

/**
 * @generated from message nodebase.v1.AdminTrafficStatsRequest
 */
export type AdminTrafficStatsRequest = Message<"nodebase.v1.AdminTrafficStatsRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * How many days back to aggregate; 0 means 30.
   *
   * @generated from field: int32 days = 2;
   */
  days: number;

  /**
   * Empty means every account. When set, usage and hourly rows are restricted
   * to this account. Global anonymous routing signals remain global because no
   * user-to-destination or user-to-endpoint relation exists in storage.
   *
   * @generated from field: string account_id = 3;
   */
  accountId: string;
};

/**
 * Describes the message nodebase.v1.AdminTrafficStatsRequest.
 * Use `create(AdminTrafficStatsRequestSchema)` to create a new message.
 */
export const AdminTrafficStatsRequestSchema: GenMessage<AdminTrafficStatsRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 60);

/**
 * AdminWorkspaceUsage is one workspace's complete metered egress over the
 * requested range. It carries source-split byte totals and nothing about
 * destinations.
 *
 * @generated from message nodebase.v1.AdminWorkspaceUsage
 */
export type AdminWorkspaceUsage = Message<"nodebase.v1.AdminWorkspaceUsage"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string owner_email = 2;
   */
  ownerEmail: string;

  /**
   * @generated from field: int64 up_bytes = 3;
   */
  upBytes: bigint;

  /**
   * @generated from field: int64 down_bytes = 4;
   */
  downBytes: bigint;

  /**
   * @generated from field: int64 connections = 5;
   */
  connections: bigint;

  /**
   * Source split behind the totals above. Worker egress and Managed Edge Exit
   * are disjoint in the current architecture; old device_exit/worker_exit Edge
   * cutover rows are excluded.
   *
   * @generated from field: int64 worker_up_bytes = 6;
   */
  workerUpBytes: bigint;

  /**
   * @generated from field: int64 worker_down_bytes = 7;
   */
  workerDownBytes: bigint;

  /**
   * @generated from field: int64 worker_connections = 8;
   */
  workerConnections: bigint;

  /**
   * @generated from field: int64 edge_up_bytes = 9;
   */
  edgeUpBytes: bigint;

  /**
   * @generated from field: int64 edge_down_bytes = 10;
   */
  edgeDownBytes: bigint;

  /**
   * @generated from field: int64 edge_connections = 11;
   */
  edgeConnections: bigint;
};

/**
 * Describes the message nodebase.v1.AdminWorkspaceUsage.
 * Use `create(AdminWorkspaceUsageSchema)` to create a new message.
 */
export const AdminWorkspaceUsageSchema: GenMessage<AdminWorkspaceUsage> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 61);

/**
 * AdminTrafficHour is the existing UTC-hour accounting ledger, not a second
 * metrics pipeline. The current Edge hour is cumulative and therefore near
 * real-time; Worker windows close at the hour boundary while heartbeat rates
 * provide the live Worker view.
 *
 * @generated from message nodebase.v1.AdminTrafficHour
 */
export type AdminTrafficHour = Message<"nodebase.v1.AdminTrafficHour"> & {
  /**
   * @generated from field: int64 window_start_unix = 1;
   */
  windowStartUnix: bigint;

  /**
   * @generated from field: int64 worker_up_bytes = 2;
   */
  workerUpBytes: bigint;

  /**
   * @generated from field: int64 worker_down_bytes = 3;
   */
  workerDownBytes: bigint;

  /**
   * @generated from field: int64 worker_connections = 4;
   */
  workerConnections: bigint;

  /**
   * @generated from field: int64 edge_up_bytes = 5;
   */
  edgeUpBytes: bigint;

  /**
   * @generated from field: int64 edge_down_bytes = 6;
   */
  edgeDownBytes: bigint;

  /**
   * @generated from field: int64 edge_connections = 7;
   */
  edgeConnections: bigint;
};

/**
 * Describes the message nodebase.v1.AdminTrafficHour.
 * Use `create(AdminTrafficHourSchema)` to create a new message.
 */
export const AdminTrafficHourSchema: GenMessage<AdminTrafficHour> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 62);

/**
 * AdminDestStat is one global destination bucket: all workspaces merged, no
 * per-user dimension exists in storage (worker.proto ReportTraffic).
 *
 * @generated from message nodebase.v1.AdminDestStat
 */
export type AdminDestStat = Message<"nodebase.v1.AdminDestStat"> & {
  /**
   * domain | region | other
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * eTLD+1 for domains, ISO country code for regions, "(other)" for the
   * aggregate tail bucket.
   *
   * @generated from field: string dest = 2;
   */
  dest: string;

  /**
   * @generated from field: int64 bytes = 3;
   */
  bytes: bigint;

  /**
   * @generated from field: int64 connections = 4;
   */
  connections: bigint;

  /**
   * Path-quality sums (worker.proto TrafficDest): avg dial latency is
   * dial_ms_total / dials; timeouts vs other failures separate the path
   * problem from the destination problem.
   *
   * @generated from field: int64 dials = 5;
   */
  dials: bigint;

  /**
   * @generated from field: int64 dial_ms_total = 6;
   */
  dialMsTotal: bigint;

  /**
   * @generated from field: int64 dial_timeouts = 7;
   */
  dialTimeouts: bigint;

  /**
   * @generated from field: int64 dial_failures = 8;
   */
  dialFailures: bigint;
};

/**
 * Describes the message nodebase.v1.AdminDestStat.
 * Use `create(AdminDestStatSchema)` to create a new message.
 */
export const AdminDestStatSchema: GenMessage<AdminDestStat> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 63);

/**
 * AdminEndpointStat is one data-plane endpoint's aggregate over the requested
 * range (endpoint_stats day buckets): how much live tunnel time it held, how
 * often devices rotated away from it — the instability vote — and the bytes
 * attributed to it from per-peer heartbeat deltas. Global buckets, no user
 * dimension. Endpoints nobody tried produce no row: absence is not stability.
 *
 * @generated from message nodebase.v1.AdminEndpointStat
 */
export type AdminEndpointStat = Message<"nodebase.v1.AdminEndpointStat"> & {
  /**
   * @generated from field: string host = 1;
   */
  host: string;

  /**
   * @generated from field: uint32 port = 2;
   */
  port: number;

  /**
   * @generated from field: nodebase.v1.Transport transport = 3;
   */
  transport: Transport;

  /**
   * @generated from field: int64 reports = 4;
   */
  reports: bigint;

  /**
   * @generated from field: int64 live_seconds = 5;
   */
  liveSeconds: bigint;

  /**
   * @generated from field: int64 rotations_away = 6;
   */
  rotationsAway: bigint;

  /**
   * @generated from field: int64 rx_bytes = 7;
   */
  rxBytes: bigint;

  /**
   * @generated from field: int64 tx_bytes = 8;
   */
  txBytes: bigint;
};

/**
 * Describes the message nodebase.v1.AdminEndpointStat.
 * Use `create(AdminEndpointStatSchema)` to create a new message.
 */
export const AdminEndpointStatSchema: GenMessage<AdminEndpointStat> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 64);

/**
 * @generated from message nodebase.v1.AdminTrafficStatsResponse
 */
export type AdminTrafficStatsResponse = Message<"nodebase.v1.AdminTrafficStatsResponse"> & {
  /**
   * @generated from field: repeated nodebase.v1.AdminWorkspaceUsage usage = 1;
   */
  usage: AdminWorkspaceUsage[];

  /**
   * @generated from field: repeated nodebase.v1.AdminDestStat dests = 2;
   */
  dests: AdminDestStat[];

  /**
   * @generated from field: repeated nodebase.v1.AdminEndpointStat endpoints = 3;
   */
  endpoints: AdminEndpointStat[];

  /**
   * @generated from field: repeated nodebase.v1.AdminTrafficHour hours = 4;
   */
  hours: AdminTrafficHour[];
};

/**
 * Describes the message nodebase.v1.AdminTrafficStatsResponse.
 * Use `create(AdminTrafficStatsResponseSchema)` to create a new message.
 */
export const AdminTrafficStatsResponseSchema: GenMessage<AdminTrafficStatsResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 65);

/**
 * Testing-stage resource catalog, independent of subscriptions and pricing.
 *
 * @generated from message nodebase.v1.WorkerTier
 */
export type WorkerTier = Message<"nodebase.v1.WorkerTier"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: nodebase.v1.WorkerSpec spec = 3;
   */
  spec?: WorkerSpec | undefined;
};

/**
 * Describes the message nodebase.v1.WorkerTier.
 * Use `create(WorkerTierSchema)` to create a new message.
 */
export const WorkerTierSchema: GenMessage<WorkerTier> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 66);

/**
 * @generated from message nodebase.v1.WorkerTierChange
 */
export type WorkerTierChange = Message<"nodebase.v1.WorkerTierChange"> & {
  /**
   * @generated from field: string tier = 1;
   */
  tier: string;

  /**
   * applying, succeeded, failed. Failed changes require operator retry.
   *
   * @generated from field: string state = 2;
   */
  state: string;

  /**
   * @generated from field: string error = 3;
   */
  error: string;

  /**
   * @generated from field: int64 updated_unix = 4;
   */
  updatedUnix: bigint;
};

/**
 * Describes the message nodebase.v1.WorkerTierChange.
 * Use `create(WorkerTierChangeSchema)` to create a new message.
 */
export const WorkerTierChangeSchema: GenMessage<WorkerTierChange> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 67);

/**
 * @generated from message nodebase.v1.AdminSetWorkerTierRequest
 */
export type AdminSetWorkerTierRequest = Message<"nodebase.v1.AdminSetWorkerTierRequest"> & {
  /**
   * @generated from field: string worker_id = 1;
   */
  workerId: string;

  /**
   * @generated from field: string tier = 2;
   */
  tier: string;

  /**
   * Reject a stale dialog before interrupting any sessions.
   *
   * @generated from field: nodebase.v1.WorkerSpec expected_spec = 3;
   */
  expectedSpec?: WorkerSpec | undefined;
};

/**
 * Describes the message nodebase.v1.AdminSetWorkerTierRequest.
 * Use `create(AdminSetWorkerTierRequestSchema)` to create a new message.
 */
export const AdminSetWorkerTierRequestSchema: GenMessage<AdminSetWorkerTierRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 68);

/**
 * @generated from message nodebase.v1.AdminSetWorkerTierResponse
 */
export type AdminSetWorkerTierResponse = Message<"nodebase.v1.AdminSetWorkerTierResponse"> & {
  /**
   * @generated from field: nodebase.v1.WorkerTierChange change = 1;
   */
  change?: WorkerTierChange | undefined;
};

/**
 * Describes the message nodebase.v1.AdminSetWorkerTierResponse.
 * Use `create(AdminSetWorkerTierResponseSchema)` to create a new message.
 */
export const AdminSetWorkerTierResponseSchema: GenMessage<AdminSetWorkerTierResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_admin, 69);

/**
 * @generated from enum nodebase.v1.AccountCohort
 */
export enum AccountCohort {
  /**
   * @generated from enum value: ACCOUNT_COHORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACCOUNT_COHORT_STANDARD = 1;
   */
  STANDARD = 1,

  /**
   * @generated from enum value: ACCOUNT_COHORT_EARLY_ACCESS = 2;
   */
  EARLY_ACCESS = 2,

  /**
   * @generated from enum value: ACCOUNT_COHORT_INTERNAL = 3;
   */
  INTERNAL = 3,
}

/**
 * Describes the enum nodebase.v1.AccountCohort.
 */
export const AccountCohortSchema: GenEnum<AccountCohort> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_admin, 0);

/**
 * @generated from enum nodebase.v1.FeatureRolloutStage
 */
export enum FeatureRolloutStage {
  /**
   * @generated from enum value: FEATURE_ROLLOUT_STAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FEATURE_ROLLOUT_STAGE_OFF = 1;
   */
  OFF = 1,

  /**
   * @generated from enum value: FEATURE_ROLLOUT_STAGE_INTERNAL = 2;
   */
  INTERNAL = 2,

  /**
   * @generated from enum value: FEATURE_ROLLOUT_STAGE_EARLY_ACCESS = 3;
   */
  EARLY_ACCESS = 3,

  /**
   * @generated from enum value: FEATURE_ROLLOUT_STAGE_ALL = 4;
   */
  ALL = 4,
}

/**
 * Describes the enum nodebase.v1.FeatureRolloutStage.
 */
export const FeatureRolloutStageSchema: GenEnum<FeatureRolloutStage> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_admin, 1);

/**
 * @generated from enum nodebase.v1.WorkspaceFeatureOverrideMode
 */
export enum WorkspaceFeatureOverrideMode {
  /**
   * @generated from enum value: WORKSPACE_FEATURE_OVERRIDE_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKSPACE_FEATURE_OVERRIDE_MODE_INHERIT = 1;
   */
  INHERIT = 1,

  /**
   * @generated from enum value: WORKSPACE_FEATURE_OVERRIDE_MODE_DENY = 2;
   */
  DENY = 2,
}

/**
 * Describes the enum nodebase.v1.WorkspaceFeatureOverrideMode.
 */
export const WorkspaceFeatureOverrideModeSchema: GenEnum<WorkspaceFeatureOverrideMode> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_admin, 2);

/**
 * AdminService is the operator overview (technical plan §4.5 "admin（内部）",
 * minimal form). Callers authenticate like any account, then must be listed in
 * NODEBASE_ADMIN_EMAILS; there is no separate admin credential.
 *
 * @generated from service nodebase.v1.AdminService
 */
export const AdminService: GenService<{
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminListServices
   */
  adminListServices: {
    methodKind: "unary";
    input: typeof AdminListServicesRequestSchema;
    output: typeof AdminListServicesResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminInspectWorkerVM
   */
  adminInspectWorkerVM: {
    methodKind: "unary";
    input: typeof AdminInspectWorkerVMRequestSchema;
    output: typeof AdminInspectWorkerVMResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminManageWorkerVM
   */
  adminManageWorkerVM: {
    methodKind: "unary";
    input: typeof AdminManageWorkerVMRequestSchema;
    output: typeof AdminManageWorkerVMResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminListAccounts
   */
  adminListAccounts: {
    methodKind: "unary";
    input: typeof AdminListAccountsRequestSchema;
    output: typeof AdminListAccountsResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminSetAccountCohorts
   */
  adminSetAccountCohorts: {
    methodKind: "unary";
    input: typeof AdminSetAccountCohortsRequestSchema;
    output: typeof AdminSetAccountCohortsResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminListFeatureRollouts
   */
  adminListFeatureRollouts: {
    methodKind: "unary";
    input: typeof AdminListFeatureRolloutsRequestSchema;
    output: typeof AdminListFeatureRolloutsResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminSetFeatureRollout
   */
  adminSetFeatureRollout: {
    methodKind: "unary";
    input: typeof AdminSetFeatureRolloutRequestSchema;
    output: typeof AdminSetFeatureRolloutResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminSetWorkspaceFeatureOverride
   */
  adminSetWorkspaceFeatureOverride: {
    methodKind: "unary";
    input: typeof AdminSetWorkspaceFeatureOverrideRequestSchema;
    output: typeof AdminSetWorkspaceFeatureOverrideResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminListFeatureAudit
   */
  adminListFeatureAudit: {
    methodKind: "unary";
    input: typeof AdminListFeatureAuditRequestSchema;
    output: typeof AdminListFeatureAuditResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminListWorkers
   */
  adminListWorkers: {
    methodKind: "unary";
    input: typeof AdminListWorkersRequestSchema;
    output: typeof AdminListWorkersResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminListDevices
   */
  adminListDevices: {
    methodKind: "unary";
    input: typeof AdminListDevicesRequestSchema;
    output: typeof AdminListDevicesResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminSetDevicePrivateLaneCount
   */
  adminSetDevicePrivateLaneCount: {
    methodKind: "unary";
    input: typeof AdminSetDevicePrivateLaneCountRequestSchema;
    output: typeof AdminSetDevicePrivateLaneCountResponseSchema;
  },
  /**
   * Invites gate account creation. They are on the admin surface rather than a
   * host-only subcommand because this surface already has the thing that was
   * missing when the CLI was the only option: an authenticated notion of who
   * an operator is.
   *
   * @generated from rpc nodebase.v1.AdminService.AdminCreateInvites
   */
  adminCreateInvites: {
    methodKind: "unary";
    input: typeof AdminCreateInvitesRequestSchema;
    output: typeof AdminCreateInvitesResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminListInvites
   */
  adminListInvites: {
    methodKind: "unary";
    input: typeof AdminListInvitesRequestSchema;
    output: typeof AdminListInvitesResponseSchema;
  },
  /**
   * Queue a durable native VM CPU/memory change; existing disks are retained.
   *
   * @generated from rpc nodebase.v1.AdminService.AdminSetWorkerTier
   */
  adminSetWorkerTier: {
    methodKind: "unary";
    input: typeof AdminSetWorkerTierRequestSchema;
    output: typeof AdminSetWorkerTierResponseSchema;
  },
  /**
   * AdminSetWorkerSpec resizes a legacy container worker's capacity in place — no rebuild, no
   * restart, running sessions survive. The floor is the Lite Worker baseline:
   * below it the agent and a usable shell do not fit, so a smaller figure is a
   * mistake, not a plan.
   *
   * @generated from rpc nodebase.v1.AdminService.AdminSetWorkerSpec
   */
  adminSetWorkerSpec: {
    methodKind: "unary";
    input: typeof AdminSetWorkerSpecRequestSchema;
    output: typeof AdminSetWorkerSpecResponseSchema;
  },
  /**
   * Assigns a workspace's outbound traffic to an exit IP, or clears it.
   * Several workspaces may share one assigned IP. Native VM source rules
   * update live for new connections; a container may need a rebuild to
   * acquire the binding's reserved source address.
   *
   * @generated from rpc nodebase.v1.AdminService.AdminSetExitBinding
   */
  adminSetExitBinding: {
    methodKind: "unary";
    input: typeof AdminSetExitBindingRequestSchema;
    output: typeof AdminSetExitBindingResponseSchema;
  },
  /**
   * AdminTrafficStats is the operator traffic view: per-workspace Worker and
   * Managed Edge Exit ledgers, plus global anonymous routing signals. Account
   * filters never apply to the latter — see ReportTraffic in worker.proto for
   * the privacy contract.
   *
   * @generated from rpc nodebase.v1.AdminService.AdminTrafficStats
   */
  adminTrafficStats: {
    methodKind: "unary";
    input: typeof AdminTrafficStatsRequestSchema;
    output: typeof AdminTrafficStatsResponseSchema;
  },
  /**
   * Edge nodes are operator infrastructure. Create returns a one-time
   * bootstrap token; assignments are explicit canaries until automatic
   * capacity scheduling is proven in M2.
   *
   * @generated from rpc nodebase.v1.AdminService.AdminCreateEdge
   */
  adminCreateEdge: {
    methodKind: "unary";
    input: typeof AdminCreateEdgeRequestSchema;
    output: typeof AdminCreateEdgeResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminListEdges
   */
  adminListEdges: {
    methodKind: "unary";
    input: typeof AdminListEdgesRequestSchema;
    output: typeof AdminListEdgesResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminSetEdgeAssignment
   */
  adminSetEdgeAssignment: {
    methodKind: "unary";
    input: typeof AdminSetEdgeAssignmentRequestSchema;
    output: typeof AdminSetEdgeAssignmentResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminSetEdgeRoles
   */
  adminSetEdgeRoles: {
    methodKind: "unary";
    input: typeof AdminSetEdgeRolesRequestSchema;
    output: typeof AdminSetEdgeRolesResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminSetEdgeEndpoints
   */
  adminSetEdgeEndpoints: {
    methodKind: "unary";
    input: typeof AdminSetEdgeEndpointsRequestSchema;
    output: typeof AdminSetEdgeEndpointsResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminSetEdgeCapacity
   */
  adminSetEdgeCapacity: {
    methodKind: "unary";
    input: typeof AdminSetEdgeCapacityRequestSchema;
    output: typeof AdminSetEdgeCapacityResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminSetWorkspaceEntitlement
   */
  adminSetWorkspaceEntitlement: {
    methodKind: "unary";
    input: typeof AdminSetWorkspaceEntitlementRequestSchema;
    output: typeof AdminSetWorkspaceEntitlementResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AdminService.AdminRevokeEdge
   */
  adminRevokeEdge: {
    methodKind: "unary";
    input: typeof AdminRevokeEdgeRequestSchema;
    output: typeof AdminRevokeEdgeResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_nodebase_v1_admin, 0);

